module.exports = __webpack_public_path__ + "img/wifi_signal_3.b5625141.svg";